import { z } from "zod";

export const PlatformMainServicesEnum = {
  ARBITRAGE: "ARBITRAGE",
  LOAN: "LOAN",
  TRADE: "TRADE",
} as const;

export const platformMainServicesSchema = z.enum([
  PlatformMainServicesEnum.ARBITRAGE,
  PlatformMainServicesEnum.LOAN,
  PlatformMainServicesEnum.TRADE,
]);

export type PlatformMainServices = z.infer<
  typeof platformMainServicesSchema
>;